<template>
  <div v-if="!returnSectionFinish">
    <form @submit.prevent="onSubmit">
      <h4>
        32. Koje sve usluge I MI Boke su Vam potrebne? <br />Možete izabrati
        više odgovora
      </h4>
      <div class="relative">
        <MultiSelect
          v-model="selectedService"
          :options="services"
          optionLabel="period"
          placeholder="Izaberite"
          :maxSelectedLabels="20"
          appendTo="body"
        />
      </div>

      <h4>33. Davanje saglasnosti za prikupljanje podataka</h4>
      <div class="button-container">
        <div class="checkbox-label">
          <RadioButton
            name="giveConsent"
            value="Da"
            inputId="giveConsent-da"
            v-model="consent"
          />
          <label for="giveConsent-da" class="label">Da</label>
          <RadioButton
            name="giveConsent"
            value="Ne"
            inputId="giveConsent-ne"
            v-model="consent"
          />
          <label for="giveConsent-ne" class="label">Ne</label>
        </div>
      </div>

      <div v-for="selected in selectedService || []" :key="selected.period">
        <div v-if="selected.period !== FREE_LEGAL_AID">
          <h4>Da li želite sada da podnesete zahtjev za: {{ selected.period }}?</h4>
          <div class="button-container">
            <div class="checkbox-label">
              <RadioButton
                :name="requestGroupName(selected)"
                value="Da"
                :inputId="`${requestGroupName(selected)}-da`"
                v-model="requestAnswers[selected.period]"
              />
              <label :for="`${requestGroupName(selected)}-da`" class="label">Da</label>
              <RadioButton
                :name="requestGroupName(selected)"
                value="Ne"
                :inputId="`${requestGroupName(selected)}-ne`"
                v-model="requestAnswers[selected.period]"
              />
              <label :for="`${requestGroupName(selected)}-ne`" class="label">Ne</label>
            </div>
          </div>
        </div>
      </div>

      <div class="button-container">
        <Button
          @click="goBack"
          type="button"
          outlined
          class="sendAnswers"
          style="margin-right: 5px;"
        >
          Nazad
        </Button>

        <Button type="submit" class="sendAnswers" :loading="isSubmitting" :disabled="isSubmitting">
          {{ isSubmitting ? 'Šaljem...' : 'Pošalji odgovore' }}
        </Button>
      </div>
    </form>
  </div>
  <SectionFinish v-if="returnSectionFinish" />
</template>

<script setup>
import SectionFinish from "./SectionFinish.vue";
import { inject, ref, reactive, provide, nextTick } from "vue";
import { useToast } from "primevue/usetoast";

const toast = useToast();
const isSubmitting = ref(false);

const objekat = inject("objekat");
const pageContainer = inject("pageContainer");

// Za ovu uslugu se ne postavlja pitanje "da li želite sada da podnesete zahtjev"
const FREE_LEGAL_AID = "Besplatna pravna pomoć";

const services = [
  { period: FREE_LEGAL_AID },
  { period: "Besplatan pristupačan prevoz za osobe s invaliditetom iz Boke" },
  { period: "Personalna asistencija" },
  { period: "Pomoć u kući za odrasle osobe s invaliditetom" },
  { period: "Pomoć u kući za roditelje djece s invaliditetom" },
  { period: "Tumačenje i prevođenje na znakovni jezik" },
  { period: "Stanovanje uz podršku" },
  {
    period:
      "SOS telefon za žene i djevojke s invaliditetom s iskustvom nasilja i diskriminacije",
  },
  { period: "Psihološko savjetovanje i terapija" },
  { period: "Grupe samopomoći" },
  { period: "Edukacija" },
  { period: "Medicinska rehabilitacija" },
  { period: "Profesionalna rehabilitacija" },
];

// Jedinstven name/id za radio grupu svake usluge (indeks usluge u listi je stabilan)
const requestGroupName = (service) => {
  const idx = services.findIndex((s) => s.period === service.period);
  return `requestYesNo-${idx >= 0 ? idx : encodeURIComponent(service.period)}`;
};

// Vraća izbor iz MultiSelect-a mapiran na objekte iz liste opcija (poređenje po "period")
function restoreSelection(options, saved) {
  if (!Array.isArray(saved)) return saved ?? null;
  return saved
    .map((item) => {
      const period = item && typeof item === "object" ? item.period : item;
      return options.find((o) => o.period === period) || (period ? { period } : null);
    })
    .filter(Boolean);
}

const selectedService = ref(restoreSelection(services, objekat.neededServicesOfMiBoka));
const consent = ref(objekat.giveConsent);

// Odgovori "Da"/"Ne" po usluzi (ključ = naziv usluge), da uklanjanje jedne usluge
// ne pomjeri odgovore na druge. Vraćamo ih iz objekta (requestYesNo je poravnat
// 1:1 sa neededServicesOfMiBoka u trenutku čuvanja).
const requestAnswers = reactive({});
if (Array.isArray(objekat.neededServicesOfMiBoka) && Array.isArray(objekat.requestYesNo)) {
  objekat.neededServicesOfMiBoka.forEach((service, i) => {
    const answer = objekat.requestYesNo[i];
    if (service && service.period && typeof answer === "string") {
      requestAnswers[service.period] = answer;
    }
  });
}

//ide naziv trenutne sekcije
const returnFourhSection = inject("returnFourhSection");

const scrollToTop = () => {
  nextTick(() => {
    if (pageContainer.value) {
      pageContainer.value.scrollTop = 0;
    } else {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  });
};

//ovdje ide naziv naredne sekcije
const returnSectionFinish = ref(false);
provide("returnSectionFinish", returnSectionFinish);

const saveToObjekat = () => {
  objekat.giveConsent = consent.value;
  objekat.neededServicesOfMiBoka = selectedService.value;
  // Backend (OsiPersonService.createOsiPerson) upisuje requestYesNo[i] u
  // neededServicesOfMiBoka[i].value po indeksu, zato niz mora biti iste dužine i redoslijeda.
  // Za "Besplatna pravna pomoć" i neodgovorene usluge šalje se null.
  const selected = Array.isArray(selectedService.value) ? selectedService.value : [];
  objekat.requestYesNo = selected.map((service) =>
    service.period === FREE_LEGAL_AID ? null : requestAnswers[service.period] ?? null
  );
};

const goBack = () => {
  // Sačuvaj unos i na povratku, da ne nestane kad se korisnik vrati naprijed
  saveToObjekat();
  returnFourhSection.value = false; // Sakrivaš četvrtu sekciju -> prikazuje se treća
  scrollToTop();
};

const onSubmit = () => {
  saveToObjekat();
  showNewForm();
};

const showNewForm = async () => {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  try {
    await sendFormData();
    returnSectionFinish.value = true;
    toast.add({
      severity: "success",
      summary: "Uspješno",
      detail: "Vaša prijava je sačuvana.",
      life: 4000,
    });
  } catch (error) {
    console.error("There was a problem with your fetch operation:", error);
    toast.add({
      severity: "error",
      summary: "Greška pri slanju",
      detail: "Nismo uspjeli da sačuvamo Vaše podatke. Molimo Vas pokušajte ponovo za par trenutaka.",
      life: 6000,
    });
  } finally {
    isSubmitting.value = false;
  }
};

const sendFormData = async () => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const response = await fetch(`${apiUrl}/osi-part/save`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(objekat),
  });
  if (!response.ok) {
    throw new Error("Network response was not ok: " + response.status);
  }
};
</script>
